
import React from 'react';
import {connect} from 'react-redux';
import { Formik, getIn } from 'formik';
import * as yup from 'yup';
import { Form, Row, Col, Collapse, Card} from 'react-bootstrap';
import Stats from '../Stats';
import NumberFormat from '../NumberFormat';
import {formatString,formatBoolean,formatPercent,formatCurrency} from '../../ApplicationHelpers';

const schema = yup.object().shape({
    checkingValue: yup.number(),
    checkingContributions: yup.number(),
    savingValue: yup.number(),
    savingContributions: yup.number(),
    investmentValue: yup.number(),
    investmentContributions: yup.number(),
    rothValue: yup.number(),
    rothContributions: yup.number()
  });
// const initialValues = {
// };
class Step6 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
  handleSubmit(values,props) {
    // console.log('---here are values',values);
    let form = this.props.form;
    let retirementAccounts = [];
    if(!form || !form.scenario || !Array.isArray(form.scenario.retirementAccounts)){
        form.scenario.retirementAccounts = [];
    }
    else{
        if(retirementAccounts.length > 1){
            retirementAccounts = retirementAccounts.filter(ra => ra.classification === 'Traditional IRA'); 
        }
        else{
            retirementAccounts = [form.scenario.retirementAccounts[0]];
        }
    }
    retirementAccounts.push({
        owner: 'client',
        classification:'1099 Interest',
        raClassification:'1099 Interest',
        investment:'Checking',
        riskAllocation: 'Low Risk',
        accountValue: values.checkingValue,
        monthlyContributionAmount: values.checkingContributions,
        withdrawalOrder:1,
            preWithdrawalOrder:1,
            rateOfReturnAfterRetirement: 0,
           rateOfReturnChange: 0,
                atRisk: formatBoolean(false),
                atRiskAmount: 0,
                lowRiskAmount: 0,
                company: formatString(''),
                accountType: formatString('Checking'),
                monthlyContributionPercentIncrease: formatPercent('0%'),
                costBasis: formatCurrency(''),
                rateOfReturn: formatPercent('0%'),
                accountIssueDate: '',
                isGuaranteedIncomeBenefit: formatBoolean(false),
                isSpia: formatBoolean(false),
                isAdvancedAssets: formatBoolean(false),
                accountModifications: [],
                guaranteedIncomeBenefit: {
                    isMonthlyPayoutMode:true
                },
                spia: {},
                beneficiaries: [],
                projectedMonthlyContributions: [],
                stateTax: true,
                savedAs: 'ra'
    });
    retirementAccounts.push({
        owner: 'client',
        classification:'Non-Qualified',
        raClassification: 'Non-Qualified',
        investment:'Checking',
        riskAllocation: 'Low Risk',
        accountValue: values.investmentValue,
        monthlyContributionAmount: values.investmentContributions,
        withdrawalOrder:2,
            preWithdrawalOrder:2,
            rateOfReturnAfterRetirement: 0,
           rateOfReturnChange: 0,
                atRisk: formatBoolean(false),
                atRiskAmount: 0,
                lowRiskAmount: 0,
                company: formatString(''),
                accountType: formatString('Checking'),
                monthlyContributionPercentIncrease: formatPercent('0%'),
                costBasis: formatCurrency(''),
                rateOfReturn: formatPercent('0%'),
                accountIssueDate: '',
                isGuaranteedIncomeBenefit: formatBoolean(false),
                isSpia: formatBoolean(false),
                isAdvancedAssets: formatBoolean(false),
                accountModifications: [],
                guaranteedIncomeBenefit: {
                    isMonthlyPayoutMode:true
                },
                spia: {},
                beneficiaries: [],
                projectedMonthlyContributions: [],
                stateTax: true,
                savedAs: 'ra'
    });
    // retirementAccounts.push({
    //     owner: 'client',
    //     classification:'1099 Interest',
    //     investment:'Money Market',
    //     riskAllocation: 'Low Risk',
    //     accountValue: values.investmentValue,
    //     monthlyContributionAmount: values.investmentContributions
    // });
    retirementAccounts.push({
        owner: 'client',
        classification:'Roth IRA',
        raClassification:'Roth IRA',
        investment:'Checking',
        riskAllocation: 'Low Risk',
        accountValue: values.rothValue,
        monthlyContributionAmount: values.rothContributions,
        withdrawalOrder:3,
            preWithdrawalOrder:3,
            rateOfReturnAfterRetirement: 0,
           rateOfReturnChange: 0,
                atRisk: formatBoolean(false),
                atRiskAmount: 0,
                lowRiskAmount: 0,
                company: formatString(''),
                accountType: formatString('Checking'),
                monthlyContributionPercentIncrease: formatPercent('0%'),
                costBasis: formatCurrency(''),
                rateOfReturn: formatPercent('0%'),
                accountIssueDate: '',
                isGuaranteedIncomeBenefit: formatBoolean(false),
                isSpia: formatBoolean(false),
                isAdvancedAssets: formatBoolean(false),
                accountModifications: [],
                guaranteedIncomeBenefit: {
                    isMonthlyPayoutMode:true
                },
                spia: {},
                beneficiaries: [],
                projectedMonthlyContributions: [],
                stateTax: true,
                savedAs: 'ra'
    });
    values= {
        retirementAccounts: retirementAccounts
    }
    this.props.upliftState(values,'scenario');
    this.props.nextStep();
    return;
  }
   
  render() {
    let isBothRetired = false, {client,scenario} = this.props.form;
    if(client.isMarried === 'true' && scenario.spouse && scenario.spouse.employment){
       if(scenario.employment.isRetired === 'true' && scenario.spouse.employment.isRetired === 'true'){
           isBothRetired = true;
       }
    }
    else if(scenario.employment.isRetired === 'true'){
       isBothRetired = true;
    }
    return(

                 <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.props}
                    validationSchema={schema}
                    onSubmit={this.handleSubmit}
                >
                {({
                        handleSubmit,
                        handleChange,
                        setFieldValue,
                        setFieldTouched,
                        values,
                        errors,
                        touched,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit} >
                            <Card className="stepChild">
                            <Card.Header>
                                <Row >
                                <span style={{'position':'absolute','paddingLeft':'15px'}}><strong>6.</strong></span>
                                    <Col md={"10"} sm={"12"} style={{'paddingLeft':'35px'}}>
                                        {this.props.getStepHeader(6) } 
                                    </Col>
                                    <Col md={"2"} sm={"12"}>
                                        <Stats type="edit" step={6} {...this.props} />
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Collapse in={this.props.isActive}>
                            <Card.Body>
                                <Form.Row>
                                    <Form.Group as={Col} md="6" controlId="validationFormikChecking">
                                    <Form.Label>Checking & Savings Account Balances</Form.Label>
                                    <NumberFormat
                                        value={values.checkingValue} 
                                        thousandSeparator={true} 
                                        prefix={'$'} 
                                        onValueChange={e => {  setFieldValue( 'checkingValue', e.floatValue);
                                                    setFieldTouched( 'checkingValue',true);  }}
                                        error={ getIn(errors,'checkingValue') }
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="6" controlId="validationFormiktotalcheckingContributions">
                                    <Form.Label>Monthly Contributions to Checking and Savings Accounts</Form.Label>
                                    <NumberFormat
                                        disabled={isBothRetired}
                                        value={values.checkingContributions} 
                                        thousandSeparator={true} 
                                        prefix={'$'} 
                                        onValueChange={e => {  setFieldValue( 'checkingContributions', e.floatValue);
                                                    setFieldTouched( 'checkingContributions',true);  }}
                                        error={ getIn(errors,'checkingContributions') }
                                        />
                                    </Form.Group>
                                </Form.Row>

                                {/* <Form.Row>
                                    <Form.Group as={Col} md="6" controlId="validationFormikChecking">
                                    <Form.Label>Savings</Form.Label>
                                    <NumberFormat
                                        value={values.savingValue} 
                                        thousandSeparator={true} 
                                        prefix={'$'} 
                                        onValueChange={e => {  setFieldValue( 'savingValue', e.floatValue);
                                                    setFieldTouched( 'savingValue',true);  }}
                                        error={ getIn(errors,'savingValue') }
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="6" controlId="validationFormiktotalsavingContributions">
                                    <Form.Label>Monthly Contributions to Accounts</Form.Label>
                                    <NumberFormat
                                        value={values.savingContributions} 
                                        thousandSeparator={true} 
                                        prefix={'$'} 
                                        onValueChange={e => {  setFieldValue( 'savingContributions', e.floatValue);
                                                    setFieldTouched( 'savingContributions',true);  }}
                                        error={ getIn(errors,'savingContributions') }
                                        />
                                    </Form.Group>
                                </Form.Row> */}

                                <Form.Row>
                                    <Form.Group as={Col} md="6" controlId="validationFormikInvestment">
                                    <Form.Label>Investment Account Balance</Form.Label>
                                    <NumberFormat
                                        value={values.investmentValue} 
                                        thousandSeparator={true} 
                                        prefix={'$'} 
                                        onValueChange={e => {  setFieldValue( 'investmentValue', e.floatValue);
                                                    setFieldTouched( 'investmentValue',true);  }}
                                        error={ getIn(errors,'investmentValue') }
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="6" controlId="validationFormiktotalinvestmentContributions">
                                    <Form.Label>Monthly Contributions to Investment Accounts</Form.Label>
                                    <NumberFormat
                                        disabled={isBothRetired}
                                        value={values.investmentContributions} 
                                        thousandSeparator={true} 
                                        prefix={'$'} 
                                        onValueChange={e => {  setFieldValue( 'investmentContributions', e.floatValue);
                                                    setFieldTouched( 'investmentContributions',true);  }}
                                        error={ getIn(errors,'investmentContributions') }
                                        />
                                    </Form.Group>
                                </Form.Row>

                                <Form.Row>
                                    <Form.Group as={Col} md="6" controlId="validationFormikroth">
                                    <Form.Label>Roth Account Balance</Form.Label>
                                    <NumberFormat
                                        value={values.rothValue} 
                                        thousandSeparator={true} 
                                        prefix={'$'} 
                                        onValueChange={e => {  setFieldValue( 'rothValue', e.floatValue);
                                                    setFieldTouched( 'rothValue',true);  }}
                                        error={ getIn(errors,'rothValue') }
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="6" controlId="validationFormiktotalrothContributions">
                                    <Form.Label>Monthly Contributions to Roth Accounts</Form.Label>
                                    <NumberFormat
                                        disabled={isBothRetired}
                                        value={values.rothContributions} 
                                        thousandSeparator={true} 
                                        prefix={'$'} 
                                        onValueChange={e => {  setFieldValue( 'rothContributions', e.floatValue);
                                                    setFieldTouched( 'rothContributions',true);  }}
                                        error={ getIn(errors,'rothContributions') }
                                        />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                            <Form.Group as={Col} md="12" style={{"padding":"0px","margin":"0px"}} controlId="step6Continue">
                                <Col md={"12"} sm={"12"}>
                                    <Stats type='continue' step={6} {...this.props} />
                                </Col>
                            </Form.Group>
                        </Form.Row>
                            </Card.Body>
                            </Collapse>
                            </Card>
                        </Form>
                    )}
                    </Formik>
    );
   }
}
const mapStateToProps = (state , ownProps) => {
    let {form} = state.mainState;
    let {client,scenario} = form;
        if(!client.isMarried || client.isMarried === 'false'){
            client.spouse = {};
            scenario.spouse = {employment:{}};
        }
        let values = {
            checkingValue: 0,
            checkingContributions: 0,
            savingValue: 0,
            savingContributions: 0,
            investmentValue: 0,
            investmentContributions: 0,
            rothValue: 0,
            rothContributions: 0
        };
        if(Array.isArray(scenario.retirementAccounts)){
            scenario.retirementAccounts.map(ra => {
                if(ra.withdrawalOrder === 1){
                    values.checkingValue = ra.accountValue;
                    values.checkingContributions = ra.monthlyContributionAmount;
                }
                // else if(ra.withdrawalOrder === 2){
                //     values.savingValue = ra.accountValue;
                //     values.savingContributions = ra.monthlyContributionAmount;
                // }
                else if(ra.withdrawalOrder === 2){
                    values.investmentValue = ra.accountValue;
                    values.investmentContributions = ra.monthlyContributionAmount;
                }
                else if(ra.withdrawalOrder === 3){
                    values.rothValue = ra.accountValue;
                    values.rothContributions = ra.monthlyContributionAmount;
                }
                return true;
            });
        }
        return {
            form,
            ...values,
            isMarried:client.isMarried,
            scenario,
            ...ownProps
        }
  }
 export default connect(
    mapStateToProps,
    null
  )(Step6)